$ = jQuery;
/* ------------------------------------------------------------*/
// FullScreen header
// -----------------------------------------
function fullscreen(){
    $('#wrapper-hero').css({
        width: jQuery(window).width(),
        height: jQuery(window).height()
    });
}
/* ------------------------------------------------------------*/
// ReplaceSVG
// -----------------------------------------
function replaceSVG() {
    $('img.svg').each(function(){
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');
    });
}

// barellRoll
// Active menu
function barellRoll() {
  "use strict";
  var triggerBttn = document.getElementById('burger-menu'),
      overlay = document.querySelector( 'div.overlay' ),
      theLogo = document.getElementById('the-logo'),
      wrap = document.querySelector('div.wrapper-menu');
// Menu mobile
    $(triggerBttn).on('click', function(){
        if (this.checked) { //open
            $(overlay).removeClass('overlay--close');
            $(overlay).addClass('overlay--slidedown');
            $(overlay).addClass('open');

            $(theLogo).addClass('logo-menu__all-white');

        } else if(!this.checked) { //close
            $(theLogo).removeClass('logo-menu__all-white')

            $(overlay).removeClass('overlay--slidedown');
            $(overlay).removeClass('open');
            $(overlay).addClass('overlay--close');
        }
    })
// On window resize
    $(window).resize(function() {
        $(theLogo).removeClass('logo-menu__all-white')

        $(overlay).removeClass('overlay--slidedown');
        $(overlay).removeClass('open');
        $(overlay).addClass('overlay--close');
    });

};

function hoverBlogPost() {
    $('.blog_item').each(function() {
        $( this ).hover(
            function() {
              $( this ).siblings().addClass('not-active');
            }, function() {
              $( this ).siblings().removeClass('not-active');
            }
          );
    })
};






$(document).ready(function(){
    barellRoll();
    replaceSVG();
    hoverBlogPost();



    $('[js-close-newsletter]').on('click', function(){
        $('.newsletter').toggleClass('is-open');
    });
});

